import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  Inject,
} from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { DialogAlertBrowserData } from './dialog-alert-browser-data';

@Component({
  selector: 'app-dialog-alert-browser',
  standalone: false,
  templateUrl: './dialog-alert-browser.component.html',
  styleUrls: ['./dialog-alert-browser.component.css'],
})
export class DialogAlertBrowserComponent implements OnInit {
  constructor(@Inject(MAT_DIALOG_DATA) public data: DialogAlertBrowserData) {}

  @Input('title') title: string;
  @Input('text') text: string;

  @Output('onClose') onClose: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit(): void {}

  close() {
    this.onClose.emit();
  }
}
